// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f04f738d","453":"8e92c3aa","455":"7b883186","977":"03e917d5"}[chunkId] + ".chunk.js";
};